// Score → color mapping, 0–10 scale.
// Mirrors the palette used in MatchCircularOverview for visual consistency.

export interface ScoreColor {
	textClass: string;
	bgClass: string;
	borderClass: string;
}

export const getScoreColor = (score: number): ScoreColor => {
	if (score >= 8)
		return {
			textClass: "text-green-700 dark:text-green-400",
			bgClass: "bg-green-50 dark:bg-green-950/40",
			borderClass: "border-green-200 dark:border-green-900",
		};
	if (score >= 6)
		return {
			textClass: "text-lime-700 dark:text-lime-400",
			bgClass: "bg-lime-50 dark:bg-lime-950/40",
			borderClass: "border-lime-200 dark:border-lime-900",
		};
	if (score >= 4)
		return {
			textClass: "text-yellow-700 dark:text-yellow-400",
			bgClass: "bg-yellow-50 dark:bg-yellow-950/40",
			borderClass: "border-yellow-200 dark:border-yellow-900",
		};
	if (score >= 2)
		return {
			textClass: "text-orange-700 dark:text-orange-400",
			bgClass: "bg-orange-50 dark:bg-orange-950/40",
			borderClass: "border-orange-200 dark:border-orange-900",
		};
	return {
		textClass: "text-red-700 dark:text-red-400",
		bgClass: "bg-red-50 dark:bg-red-950/40",
		borderClass: "border-red-200 dark:border-red-900",
	};
};
